<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">{{binominalName}}</div>
      <div slot="sub-title">{{ eventName }} </div>
      <div slot="right" class="is-pulled-right">
          <h1 class="title is-spaced is-5">{{judgeName}}</h1>
          <h2 class="subtitle is-5">{{secretaryName}}</h2>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="card">
        <div class="card-content px-0">
          <b-steps
              v-model="activeStep"
              :has-navigation="false"
              :rounded="true"
              :label-position="labelPosition"
              :mobile-mode="mobileMode"
              >
              <b-step-item step="1" label="Iniciar" type="is-success" :clickable="false">
                <init-evaluation :event-id="eventId" :execution-id="executionId" :judges-execution="selectablesJudges" @start-evaluation="startEvaluation"/>
                <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
              </b-step-item>

              <b-step-item step="2" label="Evaluar" type="is-success" :clickable="false">
                <evaluate-execution :lesson-id="lessonId" :execution-id="executionId" :judges="selectedJudge" :lesson="lesson" @show-results="showResults"/>
              </b-step-item>

              <b-step-item step="3" label="Finalizar" type="is-success" :clickable="false">
                <results-execution :execution-info="executionInfo" :scores="exercisesScores" :lesson-id="lessonId" :execution-id="executionId" :judges="selectedJudge" :lesson="lesson" @go-to-back="activeStep = 1" @finished="goToEventDetails"/>
              </b-step-item>
          </b-steps>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import HeroBar from '@/components/HeroBar'
import InitEvaluation from './components/InitEvaluation'
import EvaluateExecution from './components/EvaluateExecution'
import ResultsExecution from './components/ResultExecution'
// import EventService from '@/services/ExerciseService'

import ExecutionService from '@/services/ExecutionService'
import EventService from '@/services/EventService'

export default {
  components: {
    HeroBar,
    EvaluateExecution,
    InitEvaluation,
    ResultsExecution
  },
  created () {
    this.initView()
  },
  data () {
    return {
      activeStep: 0,
      labelPosition: 'bottom',
      mobileMode: 'compact',
      eventId: null,
      executionId: null,
      execution: null,
      lessonId: null,
      result_execution: null,
      judgesExecution: [],
      selectablesJudges: [],
      lesson: null,
      evaluation: null,
      minScore: 0,
      maxScore: 0,
      selectedJudge: null,
      componentKey: 1,
      exercisesScores: [],
      isLoading: true,
      executionInfo: {
        start_at: null,
        start_date: null,
        end_at: null,
        end_date: null,
        duration: null
      }
    }
  },
  computed: {
    judgeName () {
      let judge = this.selectedJudge ? this.selectedJudge.judge : null
      return judge ? `Juez: ${judge.name} ${judge.lastname}` : ''
    },
    secretaryName () {
      let secretary = this.selectedJudge && this.selectedJudge.secretary && (this.selectedJudge.secretary.id !== this.selectedJudge.judge.id) ? this.selectedJudge.secretary : null
      return secretary ? `Secretario: ${secretary.name} ${secretary.lastname}` : ''
    },
    binominalName () {
      let name = ''
      if (this.execution != null) {
        let horse = this.execution.horse
        let rider = this.execution.rider
        name = `${rider.lastname} ${rider.name} - ${horse.name}`
      }
      return name
    },
    eventName () {
      let event = this.evaluation ? this.evaluation.name : ''
      let lesson = this.lesson ? this.lesson.name : ''
      return `${event} - ${lesson}`
    }
  },
  methods: {
    showResults (scores) {
      this.exercisesScores = scores
      if (!this.executionInfo.end_at && !this.executionInfo.end_date) {
        this.executionInfo.end_at = this.$moment().format('HH:mm:ss')
        this.executionInfo.end_date = this.$moment().format('YYYY-MM-DD')
        let x = this.$moment(this.executionInfo.start_at, 'HH:mm:ss')
        let y = this.$moment(this.executionInfo.end_at, 'HH:mm:ss')
        this.executionInfo.duration = this.$moment.utc(y.diff(x)).format('HH:mm:ss')
      }
      this.$nextTick(() => { this.activeStep = 2 })
    },
    startEvaluation (judges) {
      this.selectedJudge = judges
      if (!this.executionInfo.start_at && !this.executionInfo.start_date) {
        this.executionInfo.start_at = this.$moment().format('HH:mm:ss')
        this.executionInfo.start_date = this.$moment().format('YYYY-MM-DD')
      }
      this.$nextTick(() => { this.activeStep = 1 })
    },
    nextStep () {
      if (this.activeStep + 1 < 4) {
        this.activeStep++
      } else {
        this.activeStep = 0
      }
    },
    async initView () {
      this.isLoading = true
      this.eventId = this.$route.params.eventId
      this.executionId = this.$route.params.executionId
      await this.getEvent()
      await this.getExecution()
      this.isLoading = false
    },
    updateView () {
      this.initView()
      this.forceRendering()
    },
    forceRendering () {
      this.componentKey++
    },
    async getExecution () {
      let response = await ExecutionService.getExecution(this.eventId, this.executionId)
      this.execution = response.data.data
      this.lessonId = this.execution.lesson.id
      this.lesson = this.execution.lesson
      this.result_execution = this.execution.result_execution
      this.judgesExecution = this.execution.judges_executions.map((judgeExecution) => {
        return {
          ...judgeExecution,
          official: true
        }
      })
      this.selectablesJudges = this.judgesExecution.filter((x) => x.status_id === 2 || x.status_id === 1)
    },
    async getEvent () {
      let response = await EventService.getEvent(this.eventId)
      this.evaluation = response.data.data
    },
    preventNav (event) {
      if (this.activeStep > 0 && !this.finished) {
        event.preventDefault()
        event.returnValue = ''
      } else {
        return true
      }
    },
    goToEventDetails () {
      this.finished = true
      this.$nextTick(() => {
        this.router.push({ name: 'evaluations.detail', params: { id: this.$route.params.eventId } })
      })
    }
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('beforeunload', this.preventNav)
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.activeStep > 0 && !this.finished) {
      if (!window.confirm('¿Seguro que desea salir sin finalzar la evaluación?')) {
        return
      }
    }
    next()
  }
}
</script>
